export function companyLogoImageSources(logoUrl: string): { primary: string; fallback?: string } {
  const t = logoUrl.trim();
  if (!t) {
    return { primary: "" };
  }
  return { primary: t };
}

export function prefetchImageUrl(url: string): void {
  const trimmed = url.trim();
  if (!trimmed) {
    return;
  }
  const img = new Image();
  img.src = trimmed;
}
